<template>
  <div class="navbar-container H-alignment">
    <img src="../../assets/logo3.png" alt="" width="50" height="50" />
    <div class="text-desc V-alignment">
      <p>为智心理</p>
      <p>专业心理咨询诊疗平台 V2.0.1</p>
    </div>
    <p class="follow-button" @click="followAcc">+ 关注</p>
  </div>
</template>

<script>
  export default {
    name: 'Navbar',
    props: {
    },
    data() {
      return {}
    },
    methods: {
      followAcc() {
        this.$emit('event-navbar-follow', {});
      }
    }
  }
</script>

<style scoped>
  .navbar-container {
    position: relative;
    padding: 6px 0 6px 10px;
    background: #FFF;
    justify-content: flex-start;
    border-radius: 5px;
    width: 100%;
  }

  .text-desc {
    margin-left: 8px;
    align-items: flex-start;
    font-size: .95rem;
    font-weight: bolder;
    color: #1e1e1e;
  }

  .text-desc > p:nth-child(2) {
    margin-top: 6px;
    font-size: .75rem;
    font-weight: 400;
    color: #606266;
  }

  .follow-button {
    position: absolute;
    right: 12px;
    background: #409EFF;
    color: #FFF;
    font-weight: bolder;
    font-size: .9rem;
    padding: 6px 12px;
    border-radius: 5px;
  }
</style>
